RivalIQ.apps.CompanyProfile.module('widgets', function (widgets, App, Backbone, Marionette, $, _) {

    'use strict';

    const PanelFooter = Marionette.ItemView.mixin({
        template: '#companyChannelPanelFooter',
        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },
        templateHelpers: function () {
            const me = this;
            return App.enums[me.getProp('channel')];
        }
    });

    const Widget = RivalIQ.apps.Dashboard.models.Widget;
    const ChannelWidget = Widget.extend({
        title: function () {
            const me = this;
            return RivalIQ.data.channels.get(me.getProp('channel')).get('name');
        },
        getPptTitle: function () {
            const me = this;
            return me.title();
        },
        description: function () {
            const me = this;

            const channel = RivalIQ.data.channels.get(me.getProp('channel'));

            if (channel.isWeb()) {
                return RivalIQ.strings.company_web_channel_info;
            }

            return RivalIQ.str('company_channel_info', channel.get('name'));
        },
        getPptSubtitle: function () {
            const me = this;

            const timezone = RivalIQ.state.landscape.get('timezone');
            return RivalIQ.utils.timePeriod.getTimePeriodDisplayString(me.getProp('timePeriod'), undefined, timezone);
        },
        shouldShowChannelWall: function () {
            const me = this;

            if (RivalIQ.props.channelRedacted(me.getProps())) {
                return me.getProp('channel');
            }
        },
        view: App.views.Channel,
        footerView: PanelFooter,
        filter: function () {
            const me = this;
            return !RivalIQ.props.channelDisplay(me.getProps());
        }
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.COMPANY_CHANNEL, ChannelWidget);
});
